import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=2c472512&scoped=true"
import script from "./RegisterDialog.vue?vue&type=script&lang=js"
export * from "./RegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterDialog.vue?vue&type=style&index=0&id=2c472512&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c472512",
  null
  
)

export default component.exports